<div class="modal-header">

    <p class="modal-title"><strong>{{header}}</strong></p>

   <button type="button" (click)="modal.dismiss('cross click')" class="btn-close" aria-label="Close"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col"></div>
        <!-- <div class="col-8 text-center mt-3"> -->
        <div class="col-3 mb-3 form-group">
            <label>Start date</label>
            <div class="input-group mb-3 date-picker-custom">
              <!-- Date input -->
              <input id="startDate" type="text" placeholder="DD-MMM-YY" class="form-control form-control-sm calendar" bsDatepicker
                     [(ngModel)]="startDate" [bsConfig]="bsConfig" #d="bsDatepicker" (bsValueChange)="onValueChange(d,'startDate')">
              <!-- Clear button -->
              <button type="button" class="btn btn-sm bg-transparent rmv-btn d-flex align-items-center border-start-0" [disabled]="d.isDisabled"
                      (click)="clear(d,'startDate')">
                <img src="design/images/close-dark.png" class="dark" width="10" height="10" alt="remove">
                <img src="design/images/close-light.png" class="light" width="10" height="10" alt="remove">
              </button>            
              <!-- Calendar toggle button -->
              <button type="button" class="btn btn-sm bg-transparent d-flex align-items-center border-start-0"
                      (click)="d.toggle()" [attr.aria-expanded]="d.isOpen">
                <img src="design/images/calendar.png" width="16" height="16" alt="calendar">
              </button>
            </div>
             <!-- Error message -->
             <div *ngIf="errorMessage" class="text-danger" style="font-size:.875em">
               {{ errorMessage }}
             </div>

            <!--<bs-datepicker-inline [bsValue]="startDate" (bsValueChange)="onStartDateChange($event)"
                 [bsConfig]="{ dateInputFormat: 'DD-MMM-YY', customTodayClass: 'custom-today-class', containerClass: 'theme-dark-blue' }"></bs-datepicker-inline>-->
        </div>
        <div class="col-3 mb-3 form-group">
        <label> End date</label>
        <div class="input-group mb-3 date-picker-custom">
        <!-- Input -->
         <input type="text" id="endDate" placeholder="DD-MMM-YY" class="form-control form-control-sm calendar" bsDatepicker 
             [(ngModel)]="endDate" [bsConfig]="bsConfig" #d2="bsDatepicker"
                (bsValueChange)="onValueChange(d2,'endDate')" [minDate]="startDate">
         
         <!-- Close button -->
         <button type="button"
                 class="btn btn-sm bg-transparent rmv-btn d-flex align-items-center border-start-0"
                 [disabled]="d2.isDisabled"
                 (click)="clear(d2,'endDate')">
           <img src="design/images/close-dark.png" class="dark" width="12" height="12" alt="remove">
           <img src="design/images/close-light.png" class="light" width="12" height="12" alt="remove">
         </button>

        <!-- Calendar button -->
        <button type="button"
                class="btn btn-sm bg-transparent d-flex align-items-center border-start-0"
                (click)="d2.toggle()"
                [attr.aria-expanded]="d2.isOpen">
          <img src="design/images/calendar.png" width="16" height="16" alt="calendar">
        </button>
        </div>
       <!-- Error message -->
       <div *ngIf="errorMessageEndDate" class="text-danger" style="font-size:.875em">
         {{ errorMessageEndDate }}
       </div>

    </div>
        <!-- </div> -->
        <div class="col"></div>
    </div>
    <div class="row">
        <div class="col text-center mt-3">
            <button class="btn btn-outline-primary me-2" (click)="modal.dismiss()"
                onclick="javascript:return false;">Close</button>
            <button (click)="onDateSubmit()" class="btn btn-secondary me-2">Select</button>
        </div>
    </div>

</div>
